import { render } from "./generic.vue?vue&type=template&id=eea2379e"
import script from "./generic.vue?vue&type=script&lang=js"
export * from "./generic.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__